export default __webpack_public_path__ + "static/media/mom.c6e476f8.svg";